import ProjectDeadlineExtensionsForm from '../../components/Form';

export default function ProjectDeadlineExtensionsCreate() {
  return <ProjectDeadlineExtensionsForm />;
}
